<script setup>
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { useTheme } from "vuetify"
import { useI18n } from "vue-i18n"

const props = defineProps({
  inline: {
    type: Boolean,
    default: false,
  },
  labelText: {
    type: String,
  },
  modelValue: {
    type: Object,
  },
  setIcon: {
    type: Boolean,
    default: false,
  },
  clearable: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  minDate: {
    type: [Date, String],
    default: null,
  },
  maxDate: {
    type: [Date, String],
    default: null,
  },
  teleport: {
    type: Boolean,
    default: false,
  },
})


const emit = defineEmits([
  'update:model-value',
  'closed',
  'open',
  'cleared',
  // Add any other events from VueDatePicker you want to support
])

const locale = useI18n().locale
const { t } = useI18n()
const { global } = useTheme()


const dateValue = computed({
  get() {
    return props.modelValue
  },
  set(newValue) {
    emit('update:model-value', newValue)
  },
})

const pickerContainer = ref(null)

const handleOpen = () => {
  if (pickerContainer.value) {
    pickerContainer.value.classList.add('opened')
  }
}

const handleClose = () => {
  if (pickerContainer.value) {
    pickerContainer.value.classList.remove('opened')
  }
}
</script>

<template>
  <div
    ref="pickerContainer"
    class="vue-date-picker-control"
  >
    <VLabel class="vue-date-picker-label">
      {{ props.labelText ?? t('actions.form.select_date') }}
    </VLabel>
    <VueDatePicker
      v-model="dateValue"
      :disabled="props.disabled"
      :placeholder="$t('actions.form.select_date')"
      :hide-input-icon="!props.setIcon"
      :clearable="props.clearable"
      hide-clear-button
      required
      :inline="props.inline"
      auto-apply
      :teleport="teleport"
      :locale="locale"
      :enable-time-picker="false"
      format="dd.MM.yyyy"
      :dark="global.name.value === 'dark'"
      :min-date="props.minDate"
      :max-date="props.maxDate"
      @open="handleOpen"
      @closed="handleClose"
    />
  </div>
</template>

<style lang="scss">
.dp__input {
  border-width: thin !important;
  border-color: rgba(var(--v-theme-on-surface), 0.2) !important;
  border-radius: 6px;
  //background-color: rgb(var(--v-theme-surface)) !important;
  background-color: transparent !important;
  font-family: Inter, sans-serif, -apple-system, blinkmacsystemfont, "Segoe UI", roboto, "Helvetica Neue", arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 15px;
  font-weight: 400;
  line-height: 1.375rem;
  min-block-size: 40px;
  opacity: 0.9;
  padding-inline: 1rem;
}

.dp__input:focus:not(:disabled),
.dp__input:hover:not(:disabled) {
  border-color: rgba(var(--v-theme-on-surface), 0.8) !important;
  opacity: 1;
}
.dp__input:disabled {
  opacity: 0.6;
}

.dp__menu {
  border-radius: 0.5rem !important;
  background: rgb(var(--v-theme-background)) !important;
}

.dp__active_date {
  border-color: rgb(var(--v-theme-primary)) !important;
  background: rgb(var(--v-theme-primary)) !important;
}

.dp__today {
  border-color: rgb(var(--v-theme-primary)) !important;
}

.vue-date-picker-control.opened {
  label {
    color: rgb(var(--v-theme-secondary)) !important;
  }

  .dp__input {
    outline: 2px solid rgb(var(--v-theme-secondary)) !important;
    outline-offset: -2px;
  }
}
</style>
